<template>
  <b-row class="m--0 cursor-pointer">
    <b-col
      cols="1"
      style="padding-right: 0px!important;padding-left: 0px!important;">
      <img
        src="@/assets/icon/form-2.png"
        class="m__t--5"
        height="40">
    </b-col>
    <b-col
      cols="11"
      class="m__t--5">
      <h4 class="m__b--0">
        {{ JSON.parse(element.info).title ? JSON.parse(element.info).title : '' }}
      </h4>
      {{ JSON.parse(element.info).name ? JSON.parse(element.info).name : '' }}
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    element: {
      type: Object,
      default: () => {},
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-card/jCreateRecordWidget.vue